import { createContext } from 'react';
// eslint-disable-next-line prettier/prettier
import {
  AttachmentResponse as AddresseeAttachmentResponse
} from '@sdir/httpclient/lib/clients/core/commonaddressee';
import { Loadable } from '../../types';

export interface ICurrentAddresseeContext {
  addresseeAttachments: Loadable<AddresseeAttachmentResponse[]>;
  getAddresseeAttachment?: (attachment: AddresseeAttachmentResponse) => Promise<File>;
}

export const CurrentAddresseeContext = createContext<ICurrentAddresseeContext>({
  addresseeAttachments: {
    loading: false,
    result: null,
    error: null,
  },
});
